import { FC } from "react";
import { Avatar, AvatarProps, Tooltip } from "antd";
import { avatarColors } from "utils/const";
import { getFileUrl } from "apis/file";
import { UserOutlined } from "@ant-design/icons";
import { User } from "@/types/user";
import {
  TipContent,
  TipInfo,
  TipName,
  TipPhone,
  TipSubName,
  TipWrap,
} from "./style";
import { useTranslation } from "react-i18next";

export type IWMSAvatar = {
  uniChar: string | null;
  avatarId: string;
  tooltip?: boolean; // 是否显示提示
  creator?: User;
} & AvatarProps;

const AvatarNode:FC<IWMSAvatar> = props => {
  const { alt,uniChar, avatarId, creator, style, ...restProps } = props;
  const color = avatarColors[(uniChar || "99").charCodeAt(0) % avatarColors.length];

  return (
    <Avatar
      style={{ backgroundColor: avatarId ? undefined : color, verticalAlign: "middle", ...style }}
      size="large"
      gap={4}
      src={avatarId ? getFileUrl(avatarId) : null}
      alt={alt ?? ''}
      {...restProps}
    >
      {
        uniChar ? alt ?? '' : <UserOutlined />
      }
    </Avatar>
  );
};

const WMSAvatar: FC<IWMSAvatar> = (props) => {
  const { tooltip = true, creator } = props;
  const {t} = useTranslation();

  const tipTitleNode = () => (
    <TipWrap>
      <TipContent>
        <TipInfo>
          <TipName>{creator?.name1 || "-"}</TipName>
          <TipSubName>{creator?.name2 || "-"}</TipSubName>
          <TipPhone>{t('sale.mobile')}: {creator?.mobile || "-"}</TipPhone>
        </TipInfo>

        <AvatarNode {...props} size={54} />
      </TipContent>
    </TipWrap>
  );

  if (!tooltip) return <AvatarNode {...props} />;

  return (
    <Tooltip
      color="white"
      title={tipTitleNode()}
      overlayInnerStyle={{
        padding: 0,
      }}
    >
      <AvatarNode {...props} />
    </Tooltip>
  );
};

export default WMSAvatar;
